import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  site: {
    title: "PaySwitch API",
    logo: {
      src: { light: "/logo-light.svg", dark: "/logo-dark.svg" },
      alt: "PaySwitch",
      width: "130px",
    },
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "category",
          label: "Getting started",
          icon: "sparkles",
          items: [
            "/introduction",
            "/authentication",
            "/metadata",
            "/return-url-and-webhooks",
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
  redirects: [{ from: "/", to: "/introduction" }],
  apis: [
    {
      type: "file",
      input: "./apis/openapi.json",
      path: "/api",
      options: {
        // Zudoku default is true — hides playground Authentication + Authorize.
        disableSecurity: false,
      },
    },
  ],
};

export default config;
